import {exists} from './general'

export function money(int, options) {
	int = Number(int)
	return int.toLocaleString('nl-NL', {currency: 'EUR', ...options, style: 'currency'})
}

export function zeroOrNaN(num) {
	return num === 0 || isNaN(num)
}

export const isOdd = num => num % 2 == 1

export const toNumberOrNull = value => {
	if (!exists(value)) return null

	const number = Number(value)
	return Number.isFinite(number) ? number : null
}
